<template>
  <div id="ManualSet">
    <template>
      <ots-main-title></ots-main-title>
      <div class="topTip">
        <span class="f18 col_black mr20">批次：{{ manualAdjustmentName }}</span>
      </div>
      <ots-table-group-new
        :selectList="selectList"
        :requestForm="requestForm"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @search="search"
      ></ots-table-group-new>
    </template>
    <ots-custom-dialog :dialog.sync="addDialog" title="批量调整" width="40%">
      <template v-slot:content>
        <div class="inputval">
          <div>调整 <el-input v-model="studentCount"></el-input>名学生去</div>
          <div class="sessionlist">
            场次
            <el-select v-model="sessionIdTag" placeholder="请选择">
              <el-option
                v-for="item in sessionIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="sessionlist">
            考场
            <el-select v-model="valueplaceId" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.classId"
                :label="item.className + '(' + item.leftSeat + ')'"
                :value="item.classId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="leftSeatshow" v-if="leftSeatshow">
            该考场剩余容量不足，确定调整吗？
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="addDialog = false">取消</el-button>
        <el-button round type="primary" @click="addSchool">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>  
  <script>
import {
  getOtherClassesFn,
  getClassesStudentCountFn,
  saveChangePlanClassFn,
} from "@/http/modules/examSet/section";
import {
  getCurrentSelectPlace,
  getPlanAllSessionByPlan,
  getClassesByPlanSessionPlaceFn,
} from "@/http/modules/examSet/planClass";
export default {
  data() {
    return {
      studentCountData: "",
      leftSeatshow: false,
      studentCount: "",
      addDialog: false,
      options: [],
      valueplaceId: "",
      selectList: [
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "name",
          value: "id",
        },
        {
          title: "考试场次",
          type: "select",
          requestKey: "sessionId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "教室名称",
          type: "select",
          requestKey: "classId",
          label: "className",
          value: "classId",
          data: [],
        },
      ],
      tableData: [],
      tableHeader: [
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "考试场次",
          prop: "sessionName",
        },
        {
          title: "教室名称",
          prop: "className",
        },
        {
          title: "考位",
          prop: "classSeatNumber",
        },
        {
          title: "教室课程",
          prop: "courseNames",
        },
        {
          title: "已安排人数",
          prop: "studentCount",
        },
        {
          title: "操作",
          type: "buttons",
          width: "160",
          btnList: [
            {
              title: "批量调整",
              click: this.allAdjustment,
            },
            {
              title: "指定学生调整",
              click: this.studentAdjustments,
            },
          ],
        },
      ],

      pagination: {
        total: 0,
      },
      requestForm: {
        classId: "",
        placeId: "",
        planId: "",
        sessionId: "",
      },
      manualAdjustmentName: "",
      classIdTarget: "",
      leftSeatNumber: "",
      sessionIdTag: "",
      sessionIdList: [],
      paramslist: [],
    };
  },
  watch: {
    "requestForm.placeId"(val) {
      this.getPlanAllSession(val);
    },
    "requestForm.sessionId"(val) {
      this.getClassesByPlanSessionPlace(val);
    },
    sessionIdTag() {
      this.getOtherClasses();
    },
    valueplaceId: function (val) {
      if (this.valueplaceId) {
        let leftSeat = this.options.filter((item) => item.classId == val);
        this.classIdTarget = leftSeat[0].classId;
        this.leftSeatNumber = leftSeat[0].leftSeat;
        if (this.studentCount > this.leftSeatNumber) {
          this.leftSeatshow = true;
        } else {
          this.leftSeatshow = false;
        }
      }
    },
    studentCount: function (val) {
      if (this.studentCount &&this.valueplaceId) {
        if (this.studentCount > this.leftSeatNumber) {
          this.leftSeatshow = true;
        } else {
          this.leftSeatshow = false;
        }
      }
    },
  },
  created() {
    this.manualAdjustmentName = this.$route.query.name;
    this.getCurrentSelect();
    this.search();
  },
  mounted() {},
  methods: {
    async getCurrentSelect() {
      let params = {
        planId: this.$route.query.id,
      };
      const { data } = await getCurrentSelectPlace(params);
      this.requestForm.placeId = "";
      this.$set(this.selectList[0], "data", data);
    },
    async getPlanAllSession(val) {
      let params = {
        planId: this.$route.query.id,
      };
      const { data } = await getPlanAllSessionByPlan(params);
      this.requestForm.sessionId = "";
      this.sessionIdList = data;
      this.$set(this.selectList[1], "data", data);
    },
    async getClassesByPlanSessionPlace() {
      let params = { ...this.requestForm };
      params.planId = this.$route.query.id;
      const { data } = await getClassesByPlanSessionPlaceFn(params);
      this.requestForm.classId = "";
      this.$set(this.selectList[2], "data", data);
    },
    // 搜索
    search() {
      let params = { ...this.requestForm };
      params.planId = this.$route.query.id;
      getClassesStudentCountFn(params).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data;
        }
      });
    },
    addSchool(row) {
      let changeTpuelist = {
        changeType: "1",
        classId: this.paramslist.classId,
        classIdTarget: this.classIdTarget,
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        studentCount: this.studentCount,
        sessionIdTarget: this.paramslist.sessionIdTarget,
      };
      if (changeTpuelist.studentCount) {
        if (this.studentCountData < changeTpuelist.studentCount) {
          this.$message.warning("录入学生数要小于等于已安排人数");
          return;
        } else {
          saveChangePlanClassFn(changeTpuelist).then((res) => {
            if (res.code == 1) {
              this.$message.warning(res.data);
              this.sessionIdTag = "";
              this.valueplaceId = "";
              this.studentCount = "";
            }
            this.addDialog = false;
            this.search();
          });
        }
      } else {
        this.$message.warning("请选择要调整人数");
      }
    },

    allAdjustment(row) {
      this.studentCount = "";
      this.valueplaceId= ''
      this.leftSeatshow= false
      this.sessionIdTag = row.sessionId;
      this.addDialog = true;
      this.studentCountData = row.studentCount;
      this.paramslist = {
        classId: row.classId,
        placeId: row.placeId,
        planId: row.planId,
        sessionId: row.sessionId,
      };
      this.getPlanAllSession();
    },
    async getOtherClasses() {
      this.paramslist.sessionIdTarget = this.sessionIdTag;
      const { data } = await getOtherClassesFn(this.paramslist);
      this.leftSeatshow = false;
      this.valueplaceId = "";
      this.classIdTarget = "";
      this.leftSeatNumber = "";
      this.options = data;
    },

    studentAdjustments(row) {
      let params = row;
      window.localStorage.setItem("paramslist", JSON.stringify(params));
      this.$router.push({
        path: "specifyAdjustments",
      });
    },
  },
};
</script>
  
  <style lang="less" scoped>
.topTip {
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #ebf0fa;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  box-sizing: border-box;
}
.sessionlist {
  margin-top: 15px;
}
.leftSeatshow {
  margin: 30px;
}
</style>
  